module.exports = __webpack_public_path__ + "static/media/haggen.6350ba5e.svg";